export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Enterprise Dashboard';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'ed_access_token',
  REFRESH_TOKEN: 'ed_refresh_token',
  USER: 'ed_user',
  THEME: 'ed_theme',
  SETTINGS: 'ed_settings',
  SIDEBAR_COLLAPSED: 'ed_sidebar_collapsed',
} as const;

export const BREAKPOINTS = {
  lg: 1200,
  md: 996,
  sm: 768,
  xs: 480,
  xxs: 0,
} as const;

export const GRID_COLS = {
  lg: 12,
  md: 10,
  sm: 6,
  xs: 4,
  xxs: 2,
} as const;

export const ROW_HEIGHT = 60;
export const GRID_MARGIN: [number, number] = [12, 12];
export const CONTAINER_PADDING: [number, number] = [0, 0];

export const DEFAULT_REFRESH_INTERVAL = 0;
export const MIN_REFRESH_INTERVAL = 5;

export const API_TIMEOUT_MS = 30000;
